module.exports = __webpack_public_path__ + "img/8.75ade5d3.png";